import React from 'react';
import pic from "../images/pic.png";

const AboutPic = () => {
  return (
    <div>
        <img src={pic} alt='profile-pic' className='image'/>
    </div>
  )
}

export default AboutPic